import React from "react";
import { Table, Pagination} from "antd";
import { AdminFlightChangesColumns } from "./AdminFlightChangesColumns.jsx";
import { SummaryChangedFields } from "~/components/flight/sections/flightDetails.jsx";

export function AdminFlightChangesTable({
  changes,
  getChanges,
  loading,
  onRowClick,
  pagination,
  currentPageNumber,
  setCurrentPage,
}) {
  const columns = AdminFlightChangesColumns();
  

  return (
    <>
      <Table
        loading={loading}
        style={{
          marginTop: 12,
          width: "95vw",
          overflowX: "auto",
          cursor: "pointer",
        }}
        pagination={false}
        size="small"
        rowKey="change_id"
        dataSource={changes}
        columns={columns}
        onRow={(flight) => {
          return {
            onClick: () => onRowClick(flight),
          };
        }}

        expandable={{
          expandedRowRender: (record) => <SummaryChangedFields updates={record.updates} />,
          }}
      />

      <Pagination
        simple={true}
        onChange={(newPage) => {
          setCurrentPage(newPage);
          getChanges(newPage);
        }}
        showSizeChanger={false}
        pageSize={100}
        current={currentPageNumber}
        hideOnSinglePage={true}
        total={pagination["numberFlights"] || 0}
      />

      
    </>
  );
}
